import Vue from "vue"
import Vuex from "vuex"
import actions from "./actions"
import getters from "./getters"
import modules from "./modules"
// import createPersistedState from 'vuex-persistedstate'
import { State } from "./getters"
Vue.use(Vuex)

const store = new Vuex.Store<State>({
    actions,
    getters,
    modules
    // plugins: [createPersistedState({
    //   key: 'baseAdmin'
    // })]
})

export default store
